import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { setIsShowGuidesNotification } from 'store/guides/actions';

import { sendAnalyticDownloadGuideClick } from 'services/analytics';

import { useDispatch, useGuides } from 'hooks';
import ErrorMessageModal from 'modals/ErrorMessageModal';

import GuidesList from 'components/GuidesList';
import Guide from 'components/GuidesList/components/Guide';
import { Text } from 'components/library';

import guidesIcon from './assets/guidesModalIcon.webp';
import { bonusGuides } from './bonusGuides';
import GuidesSkeleton from './GuidesSkeleton';

import * as S from './styled';

const Guides = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { userGuides, purchasedGuides, isLoading, isError } = useGuides();

    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

    useEffect(() => {
        dispatch(setIsShowGuidesNotification(false));
    }, []);

    useEffect(() => {
        setIsErrorModalOpen(isError);
    }, [isError]);

    return (
        <S.Container>
            <Text type="h5" center mb={12}>
                <Trans i18nKey="guides.title" />
            </Text>
            <Text type="medium-text" center mb={24}>
                <Trans i18nKey="guides.messageSent" />
            </Text>
            <S.GuidesListWrapper>
                {isLoading && <GuidesSkeleton />}

                {Boolean(purchasedGuides.length) && (
                    <GuidesList
                        guides={purchasedGuides}
                        title={t('guides.subtitle.purchased')}
                        dataLocator="purchasedGuide"
                        onDownload={sendAnalyticDownloadGuideClick}
                    />
                )}

                {Boolean(bonusGuides.length) && (
                    <GuidesList
                        guides={bonusGuides}
                        title={t('guides.subtitle.bonus')}
                        dataLocator="bonusGuide"
                        onDownload={sendAnalyticDownloadGuideClick}
                    />
                )}

                {!userGuides?.['length'] && !bonusGuides.length && !isLoading && <Guide title={t('guides.notFound')} />}
            </S.GuidesListWrapper>

            <ErrorMessageModal
                isOpen={isErrorModalOpen}
                onClose={() => setIsErrorModalOpen(false)}
                description={t('guides.error.description')}
                icon={guidesIcon}
            />
        </S.Container>
    );
};

export default Guides;
